module.exports = __webpack_public_path__ + "static/media/session.95da4226.svg";